@if(externalNumbersAvailable && externalNumbersAvailable.length > 0) {
<div [formGroup]="formGroup">
    <div  class="d-flex inputs-area">
        <mat-form-field appearance="outline" class="mat-form-field full-width">
            <mat-label>
                {{ 'customer.newAnimal.dropdown.externalNumberType' | translate }}
            </mat-label>
            <mat-select formControlName="numberType" (selectionChange)="typeChange($event)" [id]="'somExternalNumberType' + index">
                @for (externalNumberType of generateDropdown(); track externalNumberType) {
                <mat-option [value]="externalNumberType" [id]="'spnOption' + externalNumberType.id">
                    {{ externalNumberType.name }}
                </mat-option>
                }
            </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="display-block full-width">
            <mat-label>{{'customer.newAnimal.input.externalNumber' | translate}}</mat-label>
            <input matInput type="text" formControlName="number" [id]="'intNumber' + index"/>
        </mat-form-field>
    </div>
    @if (formGroup.get('number')?.invalid && formGroup.get('number')?.dirty) {
    <div class="error error-area">
        *{{'addNewCustomer.input.microchip.error' | translate}}
    </div>
    }
</div>
}